import React, { FC, PropsWithChildren } from 'react';

import Date from './Date';
import Default from './Default';
import { ButtonProps } from './props';
import Tooltip from './Tooltip';

export { default as ButtonEL } from './styles';

const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  className,
  id,
  link,
  text,
  tooltip,
  type,
  value,
  ...others
}) => {
  switch (type) {
    case 'tooltip': {
      if (!tooltip) {
        return <div>tooltip obligatoire</div>;
      }

      return (
        <Tooltip
          {...others}
          className={className}
          clipboard
          text={text}
          value={tooltip}
        >
          {children}
        </Tooltip>
      );
    }

    case 'date':
      return (
        <Date {...others} className={className} text={text} value={value}>
          {children}
        </Date>
      );

    default:
      return (
        <Default {...others} className={className} text={text}>
          {children}
        </Default>
      );
  }
};

export default Button;

export type { ButtonProps };
